import { EventInput } from '@fullcalendar/core';
import { CalendarEvent, Goal } from '@griply/types';
import { getGoalsCalendarEvents } from '@griply/utils';

const mapToEventInput = (event: CalendarEvent): EventInput => ({
  id: event.id,
  date: event.date,
  title: event.title,
  allDay: event.allDay,
  extendedProps: {
    goalId: event.goalId,
    isDeadline: event.isDeadline,
  },
});

export const getGoalsDeadlineEvents = (goals: Goal[]): EventInput[] =>
  getGoalsCalendarEvents(goals).map(mapToEventInput);
